import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

const defaultSiteId = '4';

@Component({
  selector: 'gca-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  siteSkinIsVisible: boolean;
  sub: Subscription;
  submitted = false;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.sub = this.route.queryParams.pipe(
      map(params => {
        let siteId = localStorage.getItem('siteId');
        if (params && params.siteId) {
          localStorage.setItem('siteId', params.siteId);
          siteId = localStorage.getItem('siteId');
          this.siteSkinIsVisible = siteId && siteId === defaultSiteId;
        } else {
          siteId = localStorage.getItem('siteId') || defaultSiteId;
          localStorage.setItem('siteId', siteId);
          this.siteSkinIsVisible = siteId && siteId === defaultSiteId;
        }
      })
    ).subscribe();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
